/**
 * @name Captable Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

// #region common
import API from '../config';
// #endregion

const captables = `${API.BASE_DEV_HOST}/api/cap-tables`;

export const byId = `${captables}`;
export const captableById = (id: number) => `${captables}/${id}`;
export const updateSecurititesById = (id: number) => `${captables}/${id}/securities`;
export const updateFundOwnershipById = (id: number) => `${captables}/${id}/fund-ownership`;
export const createProforma = () => `${captables}/pro-forma`;
export const primaryCaptableByCompanyDate = (companyDate: string) => `${captables}/${companyDate}/primary`;
export const gotFinalAllocation = (id: number) => `${captables}/${id}/got-final-allocation`;
export const hasMeasurementDates = (id: number) => `${captables}/${id}/check-associated-measurement-date`;
export const allBreakpointsData = (id: string) => `${captables}/${id}/all-breakpoints`;
export const clearById = (capTableId: number | string) => `${captables}/${capTableId}/clear`;
export const aiEvidenceResetById = (capTableId: number | string) => `${captables}/${capTableId}/ai-evidence-reset/`;
export const acceptAiFieldsById = (securityId: number | string) =>
  `${captables}/securities/${securityId}/accept-ai-fields`;

export const acceptAllAiFieldsByCapTableId = (capTableId: number | string) =>
  `${captables}/${capTableId}/accept-all-ai-fields`;

export const dismissAiFieldsById = (securityId: number | string) =>
  `${captables}/securities/${securityId}/dismiss-ai-fields`;

export const reopenAiFieldsById = (securityId: number | string) =>
  `${captables}/securities/${securityId}/reopen-ai-fields`;

export const aiReviewBatchByCapTableId = (capTableId: number | string) => `${captables}/${capTableId}/ai-review-batch`;

export const citationReviewById = (citationId: number | string) => `${captables}/citations/${citationId}/review`;

export const mappingReview = `${captables}/mappings/review`;
